<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <form class="needs-validation" @submit.prevent="checkForm()">
        <div class="card">
          <div class="card-header">
            <h3 class="mb-0" style="text-transform: capitalize">
              Basic Details
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <base-input
                  v-uppercase
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'name')
                  }"
                  v-model="product.name"
                  name="Product Name"
                  label="Product Name"
                />
              </div>
              <div class="col-md-4">
                <base-input
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'barcode')
                  }"
                  label="Barcode"
                  name="Barcode"
                  class="custom-input"
                >
                  <el-input v-model="product.barcode" label="Barcode">
                    <el-button
                      slot="append"
                      icon="el-icon-circle-plus-outline"
                      @click="generateBarcode()"
                    />
                  </el-input>
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input v-uppercase v-model="product.hsn" label="HSN" />
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="product.purchasePrice"
                  label="Purchase Price"
                />
              </div>
              <div class="col-md-4">
                <base-input label="Select Tax" class="custom-input">
                  <el-select v-model="product.taxId">
                    <el-option
                      v-for="(item, index) in taxes"
                      :label="item.label"
                      :value="item.taxId"
                      :key="index"
                    />
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input label="Select Unit" class="custom-input">
                  <el-select v-model="product.unitId">
                    <el-option
                      v-for="(item, index) in units"
                      :label="item.label"
                      :value="item.productUnitId"
                      :key="index"
                    />
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-4">
                <base-input v-model="product.quantity" label="Total Quantity" />
              </div>

              <div class="col-md-4">
                <base-input
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'minimumQuantity')
                  }"
                  v-model="product.minimumQuantity"
                  label="Minimum Quantity"
                  type="number"
                />
              </div>
              <div class="col-md-4">
                <base-input
                  v-model="product.metadata.rackNumber"
                  label="Rack No."
                />
              </div>
              <div class="col-md-4">
                <base-input
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'branch_price')
                  }"
                  v-model="product.metadata.branch_price"
                  label="Branch Rate (₹)"
                  type="number"
                  placeholder="Price for branch customers"
                />
              </div>
              <div class="col-md-4">
                <base-input
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'supplierId')
                  }"
                  label="Supplier"
                  class="custom-input"
                >
                  <el-select v-model="product.supplierId" filterable placeholder="Select Supplier">
                    <el-option
                      v-for="(item, index) in supplierList"
                      :label="item.name"
                      :value="item.supplierId"
                      :key="index"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>
          </div>
          <hr />
          <div class="card-header">
            <h3 class="mb-0">Pricing Details</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="text-align: right">
                <base-button class="mb-4" @click="addProductPrices()"
                  >Add</base-button
                >
              </div>
            </div>
            <div
              v-for="(item, index) in product.prices"
              :key="index"
              class="row product-price-type"
            >
              <base-input label="MRP">
                <el-input v-model="item.mrp" />
              </base-input>
              <base-input label="Price">
                <el-input v-model="item.price" style />
              </base-input>
              <base-input label="From Quantity">
                <el-input v-model="item.fromQuantity" />
              </base-input>
              <base-input label="Select Unit">
                <el-select v-model="item.productPriceTypeId">
                  <el-option
                    v-for="(value, key) in productPriceTypes"
                    :key="key"
                    :value="value.productPriceTypeId"
                    :label="value.label"
                  />
                </el-select>
              </base-input>
              <base-input label="Default Disc. in %">
                <el-input v-model="item.defaultDiscount" :min="0" />
              </base-input>
              <base-input label="Start Date" style="margin-right: 10px">
                <el-date-picker
                  v-model="item.startDate"
                  type="date"
                  placeholder="Pick a day"
                />
              </base-input>
              <base-input label="To Date" style="margin-right: 10px">
                <el-date-picker
                  v-model="item.endDate"
                  type="date"
                  placeholder="Pick a day"
                />
              </base-input>
              <div v-if="product.prices.length > 1" class="remove-item">
                <span @click="removePrices(index)">
                  <i class="ni ni-fat-remove text-red" />
                </span>
              </div>
            </div>
          </div>
          <hr />
          <div class="card-header">
            <h3 class="mb-0" style="text-transform: capitalize">
              Categorization
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12" style="text-align: right">
                <base-button
                  class="mb-4"
                  type="default"
                  @click="addProductAttribute()"
                  >Add</base-button
                >
              </div>
            </div>
            <div
              v-for="(item, index) in product.productAttributes"
              :key="index"
              class="row col-md-12"
            >
              <base-input class="col-md-4" placeholder="Select Attribute">
                <el-select
                  v-model="item.attributeId"
                  @change="getAttributeValues"
                >
                  <el-option
                    v-for="(item, index) in attributes"
                    :label="item.label"
                    :value="item.attributeId"
                    :key="index"
                  />
                </el-select>
              </base-input>
              <base-input class="col-md-4">
                <el-autocomplete
                  v-uppercase
                  :fetch-suggestions="querySearch"
                  v-model="item.value"
                  class="inline-input"
                  placeholder="Please Input"
                  allow-create
                  filterable
                />
              </base-input>
              <div
                v-if="product.productAttributes.length > 1"
                class="product-attribute-remove-item col-md-2"
              >
                <span @click="removeProductAttribute(index)">
                  <i class="ni ni-fat-remove text-red" />
                </span>
              </div>
            </div>
            <base-button type="primary" native-type="submit">Save</base-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { Select, Option, DatePicker, Button, Autocomplete } from "element-ui";
import { format } from "date-fns";
import headerComponent from "../Components/HeaderComponent";
import Validator from "@/plugins/customValidator";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    "header-component": headerComponent
  },
  data: () => {
    return {
      formErrors: [],
      productAttributeValues: []
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapGetters({
      taxes: "tax/getTaxList",
      units: "product/getProductUnits",
      productPriceTypes: "product/getProductPriceTypes",
      attributes: "attribute/getAttributes",
      supplierList: "supplier/getSupplierList"
    })
  },

  mounted() {
    if (!this.$route.params.productId) {
      this.resetProduct();
    }
    if (this.$route.params.productId) {
      this.getProduct(this.$route.params.productId);
    }
    this.getTaxes();
    this.getProductUnits();
    this.getProductPriceTypes();
    this.getAttributes();
    this.getSupplierList();
  },
  methods: {
    ...mapActions({
      saveProduct: "product/saveProduct",
      getTaxes: "tax/getTaxes",
      getProductUnits: "product/getProductUnits",
      getProductPriceTypes: "product/getProductPriceTypes",
      getProductData: "product/getProduct",
      getAttributes: "attribute/getAttributes",
      updateProduct: "product/updateProduct",
      getUniqueBarcode: "product/getBarcode",
      getProduct: "product/getProduct",
      getDistinctAttributeValues: "attribute/getDistinctAttributeValues",
      getSupplierList: "supplier/getSupplierList"
    }),
    ...mapMutations({ resetProduct: "product/resetProduct" }),
    addProductAttribute() {
      this.product.productAttributes.push({
        attributeId: "",
        value: ""
      });
    },
    removeProductAttribute(index) {
      this.product.productAttributes.splice(index, 1);
    },
    addProductPrices() {
      this.product.prices.push({
        startDate: format(new Date(), "YYYY-MM-DD"),
        endDate: null,
        price: 0,
        fromQuantity: 1,
        defaultDiscount: 0,
        mrp: null,
        productPriceTypeId:
          this.productPriceTypes.length > 0
            ? this.productPriceTypes[0].productPriceTypeId
            : null
      });
    },
    removePrices(index) {
      this.product.prices.splice(index, 1);
    },
    submitProduct() {
      if (this.product.productId) {
        this.updateProduct().then(res => {
          this.$notify({
            message: "Product Updated Successfully",
            type: "success",
            title: "Success"
          });
          this.$router.push("/products/list");
        });
      } else {
        this.saveProduct()
          .then(() => {
            this.$notify({
              message: "Product Saved Successfully",
              type: "success",
              title: "Success"
            });
            this.resetProduct();
          })
          .catch(err => {
            err.response.data.details.forEach(i => {
              this.$notify({
                message: i.message,
                type: "danger",
                title: "Validation Error"
              });
            });
          });
      }
    },

    generateBarcode() {
      this.getUniqueBarcode().then(res => {
        this.product.barcode = res.data.barcode;
      });
    },
    checkForm() {
      this.formErrors = [];
      const productErrors = Validator.validateProduct(this.product);
      this.formErrors = [...productErrors];
      const retailPrice = this.productPriceTypes.find(
        i => i.label === "Retail"
      );
      const isRetailProductPrice = this.product.prices.find(
        i => i.productPriceTypeId === retailPrice.productPriceTypeId
      );
      if (!isRetailProductPrice) {
        this.formErrors.push({
          field: "Retail Price",
          msg: "Retail Price is required"
        });
      }
      if (this.product.prices.length > 0) {
        this.product.prices.forEach(i => {
          if (i.defaultDiscount === "") {
            this.formErrors.push({
              msg: "Default Discount field should not be empty!",
              field: "Default Discount"
            });
          }
        });
      }
      if (!this.formErrors.length) {
        this.submitProduct();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    },

    async getAttributeValues(attributeId) {
      this.productAttributeValues = await this.getDistinctAttributeValues(
        attributeId
      );
    },
    querySearch(queryString, cb) {
      var links = this.productAttributeValues;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    }
  }
};
</script>
<style>
.product-price-type .remove-item {
  height: 60px;
  line-height: 118px;
  text-align: center;
  padding-left: 10px;
}

.product-price-type .remove-item span {
  cursor: pointer;
}
.product-price-type .remove-item span i {
  font-size: 25px;
}

.product-price-type .el-input {
  width: 150px;
  padding-right: 5px;
  padding-left: 5px;
}

.product-price-type .el-select .el-input .el-input__inner {
  height: 40px;
}

.product-price-type .el-select {
  padding-right: 5px;
  padding-left: 5px;
}
.product-price-type .form-control-label {
  margin-left: 5px;
}

.product-attribute-remove-item span {
  cursor: pointer;
}
.product-attribute-remove-item span i {
  font-size: 25px;
}

.is-invalid input {
  border-color: #fb6340;
}

.is-invalid {
  border-color: #fb6340;
}

.error-feedback {
  width: 100%;
  margin-top: 0.15rem;
  font-size: 80%;
  color: #fb6340;
}

.custom-input .el-input__inner {
  font-size: 0.875rem;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  height: calc(1.5em + 1.25rem + 5px) !important;
}

.product-price-type {
  justify-content: space-evenly;
}
</style>
